import {Component, Injector, OnInit} from '@angular/core';
import {RouteUtil} from '../../../util/route.util';
import {BaseComponent} from '../../base.component';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {ListResponse} from '../../../network/service/list.response';
import {RequestType} from '../../../enums/request.type';
import {strings} from '../../../../value/strings';
import {DataResponse} from '../../../network/service/data.response';
import {SessionStorageUtil} from '../../../util/session.storage.util';
import {ServiceDetailsComponent} from '../dialog/service-details/service-details.component';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-favorite',
  standalone: false,
  templateUrl: './favorite.component.html',
  styleUrl: './favorite.component.scss'
})
export class FavoriteComponent extends BaseComponent implements OnInit {
  isLoadMore: boolean = true;
  entityActions?: any;
  orders?: any;
  count?: number = 0;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    if (!this.isLoadMore) {
      return;
    }
    this.serviceApi.getEntityActions(this.tableProperties.offset, this.tableProperties.limit, 'Service,Service.ServicePrices', RequestType.PAGINATE, {
      Filter: {
        Values: [{
          Field: 'Type',
          Type: 'EQ',
          Value: 'FAVOURITE',
        }]
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        if ((res.data?.length ?? 0) < this.tableProperties.limit) {
          this.isLoadMore = false;
          this.entityActions = res.data;
          this.count = res.count;
          this.entityActions.forEach((service: any) => {
            service.Service.IsFavorite = true;
          });
        } else {
          this.tableProperties.offset++;
        }
        this.getOrders();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  getOrders() {
    if (this.hasAccount()) {
      this.serviceApi.getMyOrders(undefined, undefined, 'ServicePrice', RequestType.ALL, Config.branch.BusinessId, {
        Filter: {
          Values: [{
            Field: 'Type',
            Type: 'EQ',
            Value: strings.basket,
          }]
        }
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.orders = res.data;
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    } else {
      let basket: any[] = SessionStorageUtil.loadObject(strings.basket_service_ids, []);
      // this.orders = basket.find((basketServicePrice: any) => {
      //   return servicePriceId === basketServicePrice.ServicePriceId;
      // });
      Config.basketCount = basket.length;
    }
  }

  openBackClicked() {
    this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT]).then();
  }

  onServiceClicked(object: any) {
    if (object.Service.ServicePrices?.length > 0 && object.Service.ServicePrices[0]?.ServicePriceAdditives?.length > 0) {
      this.matDialog.open(ServiceDetailsComponent, {
        width: '100%',
        height: '80%',
        data: {
          Service: object.Service,
          onSubmit: (service: any, additives: any[]) => {
            this.serviceApi.postOrders({
              ServicePriceId: service.ServicePrices[0]?.ServicePriceId,
              Count: object.Count,
              Type: strings.basket,
              ServicePriceAdditiveIds: additives,
              BranchId: Config.branch.BusinessId
            }).subscribe((res: DataResponse<any>) => {
              if (res.success) {
                if (res.data.dataValues && !res.data.previousDataValues) {
                  Config.basketCount++;
                } else if (!res.data.dataValues) {
                  Config.basketCount--;
                }
                for (const order of this.orders) {
                  if (order.ServicePriceId === object.Service.ServicePrices[0]?.ServicePriceId) {
                    order.Count = res.data.dataValues.Count;
                  }
                }
              } else {
                SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
              }
            });
          }
        }
      });
    } else {
      this.serviceApi.postOrders({
        ServicePriceId: object.Service.ServicePrices[0]?.ServicePriceId,
        Count: object.Count,
        Type: strings.basket,
        BranchId: Config.branch.BusinessId
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          if (res.data.dataValues && !res.data.previousDataValues && object.Count === 1) {
            Config.basketCount++;
          } else if (!res.data.dataValues) {
            Config.basketCount--;
          }
          for (const order of this.orders) {
            if (order.ServicePriceId === object.Service.ServicePrices[0]?.ServicePriceId) {
              order.Count = res.data.dataValues.Count;
            }
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }
}
